export function generateUUID() {
  const buffer = new Uint8Array(16);
  crypto.getRandomValues(buffer);

  // Set version to 4 (random)
  buffer[6] = (buffer[6] & 0x0f) | 0x40;
  // Set variant to RFC 4122
  buffer[8] = (buffer[8] & 0x3f) | 0x80;

  const hex = Array.from(buffer)
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('');

  return `${hex.substring(0, 8)}-${hex.substring(8, 12)}-${hex.substring(12, 16)}-${hex.substring(16, 20)}-${hex.substring(20, 32)}`;
}
